import { UserApi } from '../../../api';
import { PatchUserDto } from '../../../commonTypes/user.types';
import { useContainer } from '../../../hooks/useContainer';

type OptionalCallback = undefined | (() => void);

const useHttpPatchUser = () => {
    const userApi: UserApi = useContainer(UserApi);

    const execPatch = (body: PatchUserDto, successCallback: OptionalCallback = undefined) => {
        const { exec, clearCache, abort } = userApi.patchUser({
            body,
            onSuccess: () => {
                if (successCallback) successCallback();
                clearCache();
                return `User successfully updated!`;
            },
            onError: error => error,
        });
        exec();
        return abort;
    };

    return { execPatch };
};

export default useHttpPatchUser;
